import { useState } from "react";
import { Steps } from "rsuite";

import { useConfig } from "../../../context/config-context";

const ModalTuto = ({ onCloseModal }) => {
  const [step, setStep] = useState(0);
  const [nextButtonLabel, setNextButtonLabel] = useState(null);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const MAX_STEP = 3;

  const siteConfig = useConfig();
  const tutoConfig = siteConfig.components.modal_patient.tuto;

  const onChange = (nextStep) => {
    const currentSTEP =
      nextStep < 0 ? 0 : nextStep > MAX_STEP ? MAX_STEP : nextStep;
    if (nextStep === MAX_STEP) {
      setNextButtonLabel("Fermer");
    }
    if (nextStep === MAX_STEP + 1) {
      setButtonDisabled(true);
      onCloseModal();
    }
    setStep(currentSTEP);
  };
  const onNext = () => onChange(step + 1);
  const onPrevious = () => {
    onChange(step - 1);
    setNextButtonLabel("Suivant");
  };

  return (
    <div>
      <div className="p-4 md:px-4 flex flex-col gap-5 min-w-[500px] min-h-[300px]">
        <Steps current={step} className="font-semibold" small={true}>
          {tutoConfig.items.map((item, index) => (
            <Steps.Item key={index} title={item.label} />
          ))}
        </Steps>
        <div className="flex justify-center lg:h-[50vh] lg:w-[60vw]">
          <img
            src={
              siteConfig.medias.tuto[
                tutoConfig.items.find((item) => item.order === step).id
              ].path
            }
            className="w-full h-full"
            alt="tuto"
          />
        </div>
      </div>
      <div className="flex justify-between p-4">
        <button
          className={`rounded text-white py-1 px-5 ${
            step === 0 ? "bg-secondary" : "bg-primary hover:bg-light"
          }`}
          onClick={onPrevious}
          disabled={step === 0}
        >
          Précédent
        </button>
        <button
          className={`rounded  text-white py-1 px-5 flex justify-center items-center ${
            buttonDisabled ? "bg-secondary" : "bg-primary hover:bg-light"
          }`}
          onClick={() => onNext()}
          disabled={buttonDisabled}
        >
          {nextButtonLabel ? nextButtonLabel : "Suivant"}
        </button>
      </div>
    </div>
  );
};

export default ModalTuto;
